<template>
  <div class="about">
    <div v-if="!loggedIn">
      <h1 :class="`d-flex justify-center`">Log In</h1>
    </div>
    <div v-if="loggedIn">
      <div :class="`d-flex justify-center`">
        <!-- <v-btn text outlined>{{cookiePilotName}}</v-btn> -->
        <h1>{{ cookiePilotName }}</h1>
      </div>
      <div :class="`d-flex justify-center`">
        <h2>You are Logged In.</h2>
      </div>

      <div :class="`d-flex justify-center`">
        <h3>Go to:</h3>
      </div>
      <div :class="`d-flex justify-space-around mb-6`">
        <v-btn color="primary" rounded :to="{ name: 'CheckIn' }"
          >Box Sign-In</v-btn
        >
        <v-btn color="primary" rounded :to="{ name: 'BoxList' }">Boxes</v-btn>
        <v-btn
          color="primary"
          rounded
          :to="{ name: 'Airbox', params: { eventId: this.eventId } }"
          >Pilots</v-btn
        >
      </div>
      <!-- <div :class="`d-flex justify-center`">
        <h3>Or:</h3>
      </div>
      <div :class="`d-flex justify-space-around mb-6`">
        <v-btn color="primary" rounded @click="logOut"
          >Log Out <v-icon right small>fa-lock</v-icon>
        </v-btn>
      </div> -->
    </div>
    <div v-else>
      <v-card outlined raised>
        <div v-if="!isAlertVisible">
          <v-form v-model="isValid" :key="key">
            <UserApiSearch @selected-regid="setRegId"></UserApiSearch>
            <!-- <v-form v-model="isValid"> -->
            <AC @ac_changed="setAc"></AC>
            <v-text-field
              v-model="regid"
              outlined
              required
              :rules="regidRules"
              readonly
              v-show="false"
            ></v-text-field>
            <v-text-field
              v-model="ac"
              outlined
              required
              :rules="acRules"
              readonly
              v-show="false"
            ></v-text-field>
            <v-row>
              <v-spacer></v-spacer>
              <v-btn
                :disabled="!isValid"
                color="primary"
                @click="Login"
                :class="`d-flex justify-space-around mb-6`"
                >OK <v-icon right small>fa-user-cog</v-icon></v-btn
              >
              <v-spacer></v-spacer>
            </v-row>
          </v-form>
        </div>
        <v-card
          ><v-row class="d-flex justify-space-around mb-6"
            ><router-link to="/newuser">New user.</router-link></v-row
          ></v-card
        >
        <v-alert type="success" :value="isAlertVisible" dense>
          {{ statusResultMsg }}
        </v-alert>
        <div v-if="isWarningAlertVisible">
          <v-alert type="error" :value="isWarningAlertVisible" dense>
            {{ statusResultMsg }}
          </v-alert>
          <v-row class="d-flex justify-space-around mb-6"
            ><router-link to="/sendac">Forgot access code?</router-link></v-row
          >
        </div>
      </v-card>
    </div>
    <!-- timeout="10000" -->
    <v-snackbar
      v-model="snackbar"
      color="primary"
      timeout="5000"
      style="max-width: 400px; justify-self: center"
    >
      <v-alert text color="white" type="info">
        <h3 class="text-h10">Cookies</h3>
        <div>
          PGBox use necessary cookies as long as you are logged in. Don't worry!
        </div>
        <v-btn
          class="mx-2"
          fab
          dark
          small
          color="primary"
          absolute
          top
          right
          @click="snackbar = false"
        >
          <v-icon dark> mdi-close </v-icon>
        </v-btn>
      </v-alert>
    </v-snackbar>
    <!-- <div v-if="isAlertVisible">
      <div :class="`d-flex justify-center`">
      </div>
    </div> -->
    <!-- {{ cookieToken }} -- {{ cookieRegId }} -- {{ loggedIn }} -->
  </div>
</template>

<script>
// @ is an alias to /src
import UserApiSearch from "@/components/airbox/UserApiSearch.vue";
import AC from "@/components/Admin/Ac.vue";
import axios from "axios";

export default {
  name: "Login",
  // regid: Number,
  data() {
    return {
      regid: Number,
      ac: String,
      eventId: String,
      eyevalueac: true,
      eyevaluepw: true,
      isValid: true,
      regidRules: [(v) => !!v || "User is required"],
      acRules: [(v) => !!v || "Access code is required"],
      pwRules: [(v) => !!v || "Password is required"],
      cancellink: { to: "/checkin" },
      isAlertVisible: false,
      isWarningAlertVisible: false,
      statusResult: Number,
      statusResultMsg: String,
      statusToken: Number,
      cookieToken: Number,
      cookieRegId: Number,
      cookiePilotName: String,
      loggedIn: false,
      cancelBtnText: "",
      statuses: [],
      items: [],
      errors: [],
      loginModel: null,
      search: "",
      loading: true,
      dialog: false,
      snackbar: false,
      headers: [
        // { text: "Date", value: "Dato" },
        { text: "Role", value: "Role" },
        { text: "Description", value: "RoleDescription" },
        { text: "Event", value: "Event" },
      ],
      key: 1,
    };
  },
  created() {
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    //this.baseUrl = "http://localhost:3000/dbapi";
    this.regid = null;
    this.isValid = false;
    this.ac = null;
    this.cookiePilotName = "";
    this.eventId = "0";
    this.getCookies();
  },
  methods: {
    setRegId(id) {
      this.regid = id;
      //   console.log(id);
    },
    setAc(value) {
      this.ac = value;
      //   console.log(id);
    },
    setLogInModel() {
      var regId = this.regid;
      var ac = this.ac;
      this.loginModel = JSON.stringify({ regId, ac });
      this.$emit("login", this.loginModel);
      // location.reload();
      window.location.href = "/";
      //   console.log(id);
    },
    Login() {
      var regId = this.regid;
      var ac = this.ac;
      var toSubmit = JSON.stringify({ regId, ac });
      const uri = this.baseUrl + "/login";
      const apimethod = "login";
      //console.log(toSubmit);
      this.resetCookies();
      this.sendpost(uri, apimethod, toSubmit, 1);
      //this.getCookies();
      //console.log("Logged In in Login",this.loggedIn);
    },

    sendpost(uri, apimethod, toSubmit, type) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "POST",
        },
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          this.items = response.data;
          this.loading = false;
          if (type === 0) {
            this.statusResult = response.data.Result;
            this.statusResultMsg = response.data.ResultMsg;
            this.statusToken = response.data.Token;
            this.regid = response.data.RegId;
            this.pilotName = response.data.SearchName;
          } else {
            this.statusResult = response.data[0].Result;
            this.statusResultMsg = response.data[0].ResultMsg;
            this.statusToken = response.data[0].Token;
            this.regid = response.data[0].RegId;
            this.pilotName = response.data[0].SearchName;
            if (apimethod === "login") {
              this.setCookies();
            }
            //this.setCookies();
            //console.log("statusToken: ",this.statusToken);
          }
          if (this.statusResult == 1) {
            this.cancelBtnText = "Done";
            // console.log(response.data);
            this.setLogInModel();
          }
          this.setAlert(this.statusResult);
          //   if (this.statusResult === 1) {
          //       getstatus();
          //   }
        })
        .catch((e) => {
          this.errors.push(e);
          this.statusResult = 0;
          this.statusResultMsg = "Something went wrong!";
          this.setAlert(this.statusResult);
        });
    },
    getCookies() {
      this.cookieRegId = this.$cookies.get("pgbregid");
      this.cookieToken = this.$cookies.get("pgbtoken");
      this.cookiePilotName = this.$cookies.get("pgbname");
      this.regid = this.cookieRegId;
      this.ac = this.cookieToken;
      if (this.cookieToken > 0) {
        this.loggedIn = true;
      } else {
        this.snackbar = true;
      }
      // console.log("getCookies loggedIn", this.loggedIn);
      // console.log("getCookies cookieToken", this.cookieToken);
    },
    setCookies() {
      //Never expire: -1
      //https://www.npmjs.com/package/vue-cookies
      this.$cookies.set("pgbtoken", this.statusToken, -1);
      this.$cookies.set("pgbregid", this.regid, -1);
      this.$cookies.set("pgbname", this.pilotName, -1);
      this.getCookies();
    },
    resetCookies() {
      this.$cookies.set("pgbtoken", 0);
      this.$cookies.set("pgbregid", 0);
      this.$cookies.set("pgbname", "");
      this.loggedIn = false;
      this.getCookies();
    },
    logOut() {
      this.resetCookies();
      this.getCookies();
      this.isAlertVisible = false;
      this.key++;
    },
    setAlert(statusResult) {
      if (statusResult === 1) {
        this.isAlertVisible = true;
        this.isWarningAlertVisible = false;
      }
      if (statusResult === 0) {
        this.isWarningAlertVisible = true;
        this.isAlertVisible = false;
        this.key++;
      }
    },
    reset() {
      this.key++;
    },
  },
  components: {
    UserApiSearch,
    AC,
  },
};
</script>